import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { hardSignout, signout } from 'slices/auth';

const initialState = {
  collection: null,
  status: null,
};

export const refreshChannels = createAsyncThunk('channels/pull', async (channelsAPI) => {
  const data = await channelsAPI.all();

  return data;
});

export const channelsSlice = createSlice({
  name: 'channels',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(signout.pending, (state) => {
        state.collection = null;
        state.status = null;
      })
      .addCase(hardSignout.pending, (state) => {
        state.collection = null;
        state.status = null;
      })
      .addCase(refreshChannels.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(refreshChannels.fulfilled, (state, action) => {
        state.collection = action.payload;
      });
  },
});

export const selectChannels = (state) => state.channels.collection;

export default channelsSlice.reducer;
